export default __webpack_public_path__ + "static/media/paystub_example.abd5cb85.png";